var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.456 18.797a1.125 1.125 0 0 0 1.593 0l5.953-5.956 5.954 5.956a1.127 1.127 0 0 0 1.593-1.594l-6.75-6.75a1.124 1.124 0 0 0-1.593 0l-6.75 6.75a1.124 1.124 0 0 0 0 1.594",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 25.875a1.125 1.125 0 0 0 1.125-1.125V13.5a1.125 1.125 0 1 0-2.25 0v11.25A1.125 1.125 0 0 0 18 25.875",
    clipRule: "evenodd"
  })));
};
export default SvgArrow;